// extracted by mini-css-extract-plugin
module.exports =  {"checkbox-wrapper":"Fwp0byw","checkboxWrapper":"Fwp0byw"};